import { forwardRef } from "react";
import Dialog from '@mui/material/Dialog';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';

import {MapContainer, TileLayer, Marker, Popup} from "react-leaflet";
import CloseIcon from '@mui/icons-material/Close';
import '~/apps/App.css';
import '~/apps/common.css';

// Since Material UI V4, Dialog and Modal children must be able to hold a ref.
// Ref: https://stackoverflow.com/questions/57817994/migration-to-material-ui-v4-i-get-warning-for-modal-component
// Ref: https://reactjs.org/docs/forwarding-refs.html
const Transition = forwardRef((props, ref) => {
    return <Slide direction="up" {...props} ref={ref}/>;
})

function MapDialog({onCancel, open, activeMapLocation}) {

    const handleClose = (e) => {
        // prop close
        onCancel(e);
    };

    const position = [activeMapLocation.lat, activeMapLocation.long];

    return <div>
        <Dialog fullScreen open={open} onClose={handleClose} slots={{transition: Transition}}>
            <AppBar>
                <Toolbar>
                    <Typography variant="h2" sx={{fontSize: 22, fontWeight: "bold"}} color="inherit">Map</Typography>
                    <div className="flex-grow-1"/>
                    <IconButton color="inherit" onClick={handleClose} aria-label="Close" size="large">
                        <CloseIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div className="margin-bottom-lg"/>
            <MapContainer center={position} zoom={18} style={{width: '100%', height: '100%'}}>
                <TileLayer
                    attribution='&amp;copy <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={position}>
                    <Popup>{activeMapLocation.name}</Popup>
                </Marker>
            </MapContainer>
        </Dialog>
    </div>;
}

export default MapDialog;